// extracted by mini-css-extract-plugin
module.exports = {"bottomRow":"LandingFooter_bottomRow__2daFB","partner":"LandingFooter_partner__woXWE"};